import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'NullableBoolean'
})
export class NullableBooleanPipe implements PipeTransform {

  transform(value: any): string {
    const valueString = value.toString();
    if (_.isNil(valueString) || !valueString.length) {
      return null;
    }
    return valueString === 'true' ? 'Oui' : 'Non';
  }
}